"use client";

import { c as _c } from "react/compiler-runtime";
import { cx } from "@/lib/tailwind-utils";
import { useChatConfigContext } from "./chat-context";
export function ChatLoadingSkeleton(t0) {
  const $ = _c(22);
  const {
    size
  } = t0;
  const t1 = size === "sm" ? "mt-12" : "mt-24";
  let t2;
  if ($[0] !== t1) {
    t2 = cx("flex flex-1 flex-col space-y-4 p-4 transition-opacity duration-300", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="h-4 w-1/8 rounded bg-muted" />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = size === "sm" ? "h-12 w-1/2" : "h-20 w-1/3";
  let t5;
  if ($[3] !== t4) {
    t5 = cx("rounded-lg bg-muted", t4);
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== t5) {
    t6 = <div className="flex animate-pulse items-center"><div className="motion-preset-slide-right-sm flex-1 space-y-2">{t3}<div className={t5} /></div></div>;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="ml-auto h-4 w-1/8 rounded bg-muted" />;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const t8 = size === "sm" ? "h-12 w-1/2" : "h-20 w-1/3";
  let t9;
  if ($[8] !== t8) {
    t9 = cx("ml-auto rounded-lg bg-muted", t8);
    $[8] = t8;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== t9) {
    t10 = <div className="flex animate-pulse items-center justify-end"><div className="motion-preset-slide-left-sm flex-1 space-y-2 text-right">{t7}<div className={t9} /></div></div>;
    $[10] = t9;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div className="h-4 w-1/8 rounded bg-muted" />;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  const t12 = size === "sm" ? "h-12 w-1/2" : "h-20 w-1/3";
  let t13;
  if ($[13] !== t12) {
    t13 = cx("rounded-lg bg-muted", t12);
    $[13] = t12;
    $[14] = t13;
  } else {
    t13 = $[14];
  }
  let t14;
  if ($[15] !== t13) {
    t14 = <div className="flex animate-pulse items-center"><div className="motion-preset-slide-right-sm flex-1 space-y-2">{t11}<div className={t13} /></div></div>;
    $[15] = t13;
    $[16] = t14;
  } else {
    t14 = $[16];
  }
  let t15;
  if ($[17] !== t10 || $[18] !== t14 || $[19] !== t2 || $[20] !== t6) {
    t15 = <div className={t2}>{t6}{t10}{t14}</div>;
    $[17] = t10;
    $[18] = t14;
    $[19] = t2;
    $[20] = t6;
    $[21] = t15;
  } else {
    t15 = $[21];
  }
  return t15;
}
export function ChatLoading() {
  const $ = _c(2);
  const {
    size
  } = useChatConfigContext();
  let t0;
  if ($[0] !== size) {
    t0 = <ChatLoadingSkeleton size={size} />;
    $[0] = size;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}